import {ReactNode, useContext} from "react";
import classes from "./SubView.module.css";
import QRCodeStyleViewTypes from "../QRCodeStyleViewTypes";
import TextButton from "../../../../../_utils/button/text/TextButton";
import {Group} from "@mantine/core";
import QRCodeStyleViewContext from "../QRCodeStyleViewContext";

type SubViewProps = {
    /**
     * Children to be rendered.
     * @author Kacper Faber
     * @since 0.1.9
     */
    children: ReactNode | ReactNode[];

    /**
     * View to go back, if undefined back button will not be displayed.
     * @author Kacper Faber
     * @since 0.1.9
     */
    viewBack?: QRCodeStyleViewTypes;
};

/**
 * Renders children in a sub view - with back button.
 * @author Kacper Faber
 * @since 0.1.9
 */
function SubView(props: SubViewProps) {
    const ctx = useContext(QRCodeStyleViewContext);

    const onBackClicked = () => {
        if (props.viewBack) {
            ctx.setActiveView(props.viewBack);
        }
    };

    const renderBackButton = () => {
        if (!props.viewBack) {
            return null;
        }

        return (
            <TextButton
                s="xs"
                children="POWRÓT"
                onClick={onBackClicked}
            />
        );
    }

    return (
        <div className={classes.subView}>
            <Group justify="left">
                { renderBackButton() }
            </Group>

            {props.children}
        </div>
    );
}

export default SubView;